import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/**
 * Las retenciones practicadas y el certificado del proveedor, dentro del grupo `_contabilidad`.
 * `rep.retenciones_practicadas` y las dos del certificado exigen `contador` o `administrador`, que es
 * lo que el guardián del grupo ya admite, y la feature 17 empieza siempre con «la contadora».
 */
export const rutaRetenciones = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/retenciones',
  component: lazyRouteComponent(() => import('./retenciones-pantalla.js'), 'RutaRetenciones'),
});
